import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const installedInstances = new WeakSet<AxiosInstance>();

const inFlightRequests = new Map<string, Promise<AxiosResponse>>();

const buildAxiosRequestKey = (config: AxiosRequestConfig): string => {
  const method = (config.method ?? "get").toUpperCase();
  const baseURL = config.baseURL ?? "";
  const url = config.url ?? "";
  const params = config.params ? JSON.stringify(config.params) : "";
  const data = config.data ? JSON.stringify(config.data) : "";

  return `${method}|${baseURL}|${url}|${params}|${data}`;
};

export const installAxiosInFlightDedupe = (instance: AxiosInstance): void => {
  if (installedInstances.has(instance)) {
    return;
  }

  const originalRequest = instance.request.bind(instance);

  instance.request = ((config: AxiosRequestConfig) => {
    const requestKey = buildAxiosRequestKey(config);
    const existingRequest = inFlightRequests.get(requestKey);

    if (existingRequest) {
      return existingRequest;
    }

    const requestPromise = originalRequest(config);
    inFlightRequests.set(requestKey, requestPromise);

    const cleanup = () => {
      inFlightRequests.delete(requestKey);
    };

    requestPromise.then(cleanup, cleanup);

    return requestPromise;
  }) as AxiosInstance["request"];

  installedInstances.add(instance);
};